import {Component, OnInit, ViewChild} from '@angular/core';
import {Login} from '../login/login';
import {connectApi} from '../common/connect-api';
import {SESSION_STORAGE_KEYS} from '../common/session-storage-keys';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AllValidationErrors, getFormValidationErrors} from "../common/get-form-validation-errors";
import {PasswordRegexConstant, Utils} from "../common/utils";
import {UserAuthenticationService} from '../common/user-authentication.service';
import {ConfirmDialogService} from "../common/confirm-dialog/confirm-dialog.service";
import {ConnectDialog} from "../common/confirm-dialog/connect-dialog";
import {RecaptchaComponent} from 'ng-recaptcha';
import {Messages} from '../shared/messages';
import {NotificationService} from '../common/notification/notification.service';
import {SystemConfigurationService} from "../common/configuration/system-configuration.service";


@Component({
    selector: 'dp-connect-registration',
    templateUrl: './registration.component.html'
})
export class RegistrationComponent implements OnInit {

    @ViewChild('reCaptcha') reCaptcha: RecaptchaComponent;
    loginId: string;
    routerState: any;
    nextState: any;
    connectToken: string;

    formGroup: FormGroup;

    constructor(private  router: Router,
                public httpClient: HttpClient,
                private userAuthenticationService: UserAuthenticationService,
                public dialogService: ConfirmDialogService,
                private systemConfigurationService: SystemConfigurationService,
                public notificationService: NotificationService) {
        this.routerState = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras ? this.router.getCurrentNavigation().extras.state : undefined;
    }

    ngOnInit(): void {
        sessionStorage.clear();
        if (this.routerState) {
            this.loginId = this.routerState.loginId;
            this.nextState = this.routerState.nextState;
            this.connectToken = this.routerState.connectToken;
        }
        this.createFormControl();
    }

    isInvitedUser() : boolean {
        return (!!this.loginId && !!this.connectToken);
    }

    createFormControl() : void  {
        this.formGroup = new FormGroup({
            'firstName': new FormControl(),
            'lastName': new FormControl(),
            'loginId': new FormControl({value: this.loginId, disabled: !!this.loginId}, Validators.email),
            'password': Utils.createChangePassFormControl()
        });
        this.formGroup.addControl( 'retypePassword', new FormControl('',Validators.compose([
            // 1. Password Field is Required
            Validators.required,Utils.passwordMatchValidator(this.formGroup , { mustMatch: true })])));
    }
    register(reCaptchaToken: string): void {
        if (this.isFormValid()) {
            const login = new Login();
            login.firstName = this.formGroup.controls['firstName'].value;
            login.lastName = this.formGroup.controls['lastName'].value;
            login.loginId = this.formGroup.controls['loginId'].value;
            login.password = this.formGroup.controls['password'].value;
            login.retypePassword = this.formGroup.controls['retypePassword'].value;
            login.reCaptchaToken = reCaptchaToken;
            let api = connectApi.register;
            if(this.isInvitedUser()){
                api = connectApi.registerUnityUser.replace('{inviteToken}', this.connectToken);
            }
            if(login.loginId){
                login.loginId = login.loginId.toLowerCase();
            }
            this.httpClient.post<any>(api, login)
                .subscribe(response => {
                    if (response) {
                        if(!this.isInvitedUser()){
                            let connectDialog = new ConnectDialog();
                            connectDialog.message = 'A verification email has been sent to your address.  When the email arrives, please select the verification link it contains to complete registration.'
                            connectDialog.dialogType = 'INFORMATION';
                            connectDialog.showCancelBtn = false;
                            this.dialogService.confirmDialog(connectDialog).subscribe(
                                res => {
                                    if(res) {
                                        this.router.navigate(['./login']);
                                    }
                                }
                            );
                        }
                        else {
                            this.userAuthenticationService.login(login).subscribe(
                                (user) => {
                                    this.userAuthenticationService.setUpUserSession(user);
                                    //Load system configuration
                                    this.systemConfigurationService.loadSystemConfiguration();

                                    if (this.nextState) {
                                        sessionStorage.setItem(SESSION_STORAGE_KEYS.connectToken, this.connectToken);
                                        this.router.navigate(['./accept-terms-conditions/'], {state: {nextState: this.nextState}});
                                    } else {
                                        this.router.navigate(['./accept-terms-conditions']);
                                    }
                                }
                            );
                        }
                    }
                })
        }
    }

    isFormValid(): boolean {
        const errors: AllValidationErrors[] = getFormValidationErrors(this.formGroup.controls);
        return errors.length === 0;
    }

    async captchaResolved(reCaptchaToken: string) {
        if (reCaptchaToken) {
            // console.log(`Resolved response token: ${reCaptchaToken}`);
            this.register(reCaptchaToken);
        }
    }

    validateForm(){
        if (this.isFormValid()) {
            if (this.isInvitedUser()) {
               this.register('');
            } else {
                this.reCaptcha.execute();
            }
        }
    }
}

